import ZoneLeaflet from "../../../../../components/ZoneLeaflet";
import CardListMap from "./CardListMap";
import CustomExpandableCard from "../../../../../components/CustomExpandableCard";
import {
    IconEntryDevice,
    IconExitDevice,
    PersonChipBlack
} from "../../../../../components/buttons/IconButtons";
import { CommonMapApp } from "../../../../../components/Leaflet/CommonMapApp";
import { Box } from "@mui/material";
import CustomAutocompleteSearch from "../../../../../components/CustomAutocompleteSearch";
import {TABLES} from "../../../../../Apis/Tables";
import CustomTooltip from "../../../../../components/CustomTooltip";
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    getDateFormat,
    userListToLabelEmailPhoneValue
} from "../../../../../Apis/functions";
import NotInformation from "../../../../../components/NotInformation";
import React from "react";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 */

const AttendanceMap = ({
                           searchLocation,
                           handleChange,
                           item,
                           direction,
                           setShowDetailsModal,
                           t,
                           locations,
                           setIdEmployee,
                           attendanceByDepartment,
                           attendanceByEmployee,
                           dispatch,
                           selectEmployee,
                           setSelectEmployee,
                           option,
                           bodyDepartment,
                           handleSearch,
                           loadingMore,
                           listContainerRef,
                           searchType,
                           handleMapMove,
                           getActionsButtons,
                           cleanAutocompleteSearch,
                           setCleanAutocompleteSearch
                       }) => {

    const { companyIcon, marker, handleMarkerHover } = CommonMapApp({
        t,
        locations,
        dispatch,
    });

    const activeList = selectEmployee && attendanceByEmployee?.content && searchType === TABLES.USER
            ? attendanceByEmployee
            : attendanceByDepartment;

    const activeContent = activeList?.content ?? [];
    const totalElements = activeList?.totalElements ?? 0;

    /**
     * Formats an access timestamp as date and time.
     *
     * @param {Date|string|number} date - Entry or exit timestamp
     * @returns {string} Formatted datetime, or the no record legend when it is missing
     */
    const getAccessDateTime = (date) => date
        ? `${getDateFormat(date, false, DATE_TIME_FORMAT_NAME_MODEL.slash)} ${getDateFormat(date, false, DATE_TIME_FORMAT_NAME_MODEL.HHmm)}`
        : t('no_record');

    return (
        <>
            <div className="w-100 h-100 border-full-shades-100 border-radius-8px position-relative overflow-hidden">
                <ZoneLeaflet
                    setLatitude={(value) => handleChange({ target: { name: "latitude", value } })}
                    setLongitude={(value) => handleChange({ target: { name: "longitude", value } })}
                    latlng={[item?.latitude, item?.longitude]}
                    searchLocation={searchLocation}
                    markersList={marker}
                    disabled={true}
                    iconMarker={companyIcon}
                    onMarkerClick={(marker) => {
                        if (marker?.userId) {
                            setIdEmployee(marker.userId);
                            setShowDetailsModal(true);
                        }
                    }}
                    onMarkerHover={handleMarkerHover}
                    onMapMove={handleMapMove}
                    ifCluster={true}
                />
                    <CustomExpandableCard dividerClassName="background-shades-200 mt-2 mb-2"
                            header={
                                <div className="row p-0 m-0 gap-3 h-36px">
                                    <CustomTooltip
                                        text={direction}
                                        classes={"pl-0 fs-12px ibl-font-w-500 font-color-primary-700 text-ellipsis-2-rows text-break-wrap"}
                                        showIfTruncated={true}
                                        placement={"top"}
                                    />
                                </div>
                            }
                          searchInput = { item?.departmentId !== null &&
                              <Box className="col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 m-0 mt-2">
                                  <CustomAutocompleteSearch
                                      id="slt_atcm_employee"
                                      itemSelected={selectEmployee}
                                      setItemSelected={setSelectEmployee}
                                      bodyApi={bodyDepartment}
                                      model={option}
                                      onReset={() => handleSearch()}
                                      reset={false}
                                      listTransform={userListToLabelEmailPhoneValue}
                                      keyId={"userId"}
                                      Icon={PersonChipBlack}
                                      cleanAutocompleteSearch={cleanAutocompleteSearch}
                                      setCleanAutocompleteSearch={setCleanAutocompleteSearch}
                                  />
                              </Box>
                          }
                    >
                            <div key={searchType}
                                 ref={listContainerRef}
                                 className={`${activeList?.totalElements > 0 ? "overflow-y-auto" : " "}`}
                            >

                                    {totalElements > 0 ?
                                        activeContent.map((item,index) => (
                                            <CardListMap
                                                key={item.id}
                                                body={
                                                    <>
                                                        <div className={"flex-row d-flex justify-content-between"}>
                                                            <CustomTooltip
                                                                text={item.fullName}
                                                                classes={"w-190px text-capitalize font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-1-row"}
                                                                showIfTruncated={true}
                                                            />
                                                            {getActionsButtons(item, index)}
                                                        </div>
                                                        {/* Each bound carries its own date, since an exit can fall on a later day than its entry. */}
                                                        <div className={"d-flex justify-content-flex-start gap-3 flex-nowrap"}>
                                                            <p className={"ibl-font-w-400 font-color-shades-500 fs-14px gap-2 d-flex align-items-center minw-0 w-50"}>
                                                                <IconEntryDevice  className={"icon-color-success-600 flex-shrink-0"}/>
                                                                <CustomTooltip text={getAccessDateTime(item?.entryDate)} placement={"top"}>
                                                                    <span className={"text-ellipsis minw-0"}>{getAccessDateTime(item?.entryDate)}</span>
                                                                </CustomTooltip>
                                                            </p>
                                                            <p className={"ibl-font-w-400 font-color-shades-500 fs-14px gap-2 d-flex align-items-center minw-0 w-50"}>
                                                                <IconExitDevice className={"icon-color-error-code-600 flex-shrink-0"}/>
                                                                <CustomTooltip text={getAccessDateTime(item?.exitDate)} placement={"top"}>
                                                                    <span className={"text-ellipsis minw-0"}>{getAccessDateTime(item?.exitDate)}</span>
                                                                </CustomTooltip>
                                                            </p>
                                                        </div>
                                                    </>
                                                }
                                            />
                                        )) : <NotInformation  className={"overflow-hidden maxw-100 maxh-100"} card={true} text={t('no_results_found_for_the_date')}/>
                                    }
                                    {loadingMore && (
                                        <div className="fs-16px ibl-font-w-600 font-color-general-950 text-center">
                                            {t("loading")}
                                        </div>
                                    )}
                            </div>
                    </CustomExpandableCard>
            </div>
        </>
    );
};

export default AttendanceMap;
